<div class="body-holder">
  <app-mobile-header-menu menulink="/menu/documentos" [backButtonText]="translateService.instant('menu.documents')"></app-mobile-header-menu>

  <aside class="sidebar sidebar--mobile" [class.d-none]="!(formStep === FormSteps.mobileFile || formStep === FormSteps.signaturePositions)">
    <main class="document-signers" [class.d-none]="formStep !== FormSteps.mobileFile">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.selectFileToSign' | translate }}</div>
      </div>

      <div class="models__droparea models__merge" [class.d-none]="!!file || !isMergeFiles">
        <p class="models__droparea-title">{{ 'documents.mergeFiles' | translate }}</p>
        <p class="models__droparea-text mb-2">{{ 'documents.filesWillBeMerged' | translate }}</p>

        <ng-container [ngTemplateOutlet]="mergeFilesList"></ng-container>

        <div class="models__droparea-actions">
          <button
            type="button"
            class="models__droparea-floatingButton"
            (click)="openGooglePicker(true)"
            [disabled]="isUploadingMergeFiles()"
            [ngbTooltip]="tipGoogleDrive"
            container="body"
            placement="top"
            *ngIf="!isElectron"
          >
            <i class="fab fa-google-drive"></i>
          </button>
          <label class="btn btn-M btn-outline btn-secondary icon-start" [class.disabled]="isUploadingMergeFiles()">
            <input
              type="file"
              class="models-submit-field-file"
              multiple
              [accept]="acceptedFileMimeTypes.join(',')"
              [disabled]="isUploadingMergeFiles()"
              (change)="addMultipleFiles($event.target['files'], true); $any($event.target).value = ''"
            />
            <i class="fa fa-plus"></i> {{ 'documents.addMoreFiles' | translate }}
          </label>
          <button class="btn-M btn-outline" type="button" (click)="submitMergeFiles()" [disabled]="hasMergeFilesWithErrors() || isUploadingMergeFiles()">{{ 'button.merge' | translate }}</button>
        </div>
      </div>

      <label class="document-signers__select" [class.d-none]="!!file || isMergeFiles">
        <input
          type="file"
          class="models-submit-field-file"
          multiple
          [accept]="acceptedFileMimeTypes.join(',')"
          (change)="addMultipleFiles($event.target['files'], false); $any($event.target).value = ''"
        />
        <i class="fal fa-cloud-upload-alt"></i>
        {{ 'documents.selectFile' | translate }}
      </label>

      <div class="document-signers-top mt-3" [class.d-none]="!!file">
        <div class="document-signers-title">{{ 'documents.orSelectTemplate' | translate }}</div>
      </div>

      <div class="template" [class.d-none]="!!file">
        @if (templates && templates.length > 0) {
          <div class="template__list">
            @for (template of templates; track $index) {
              @if (!template.is_dynamic_template || (isAutentiqueUser && appService.isAutentiqueDomain())) {
                <div class="template__item">
                  @if (currentUser?.currentPermissions.actions_templates_gr) {
                    <div class="template__item-head_options" ngbDropdown placement="bottom-right" (click)="$event.preventDefault()">
                      <label ngbDropdownToggle>
                        <i class="fa-regular fa-ellipsis-v"></i>
                      </label>
                      <div ngbDropdownMenu>
                        <button type="button" (click)="openDuplicateTemplateModal(template)" ngbDropdownItem>{{ 'button.duplicate' | translate }}</button>
                        <button type="button" (click)="deleteTemplate(template)" ngbDropdownItem>{{ 'button.exclude' | translate }}</button>
                      </div>
                    </div>
                  }
                  <div class="template__item-container" (click)="fillTemplate(template)">
                    <div class="template__item-head_container">
                      <a href="javascript:void(0)" class="template__item-head">
                        <div class="template__item-head_icon">
                          <i class="fal" [class]="template.is_dynamic_template ? 'fa-brackets-curly' : 'fa-code'"></i>
                        </div>
                      </a>
                      <div class="template__item-head_text">
                        <p class="template__item-name">{{ template.name }}</p>
                        <p class="template__item-date">{{ template.user.name }}</p>
                      </div>
                    </div>

                    @if (!template.is_dynamic_template && appService.isAutentiqueDomain() && this.isAutentiqueUser) {
                      <span class="monster__badge badge-XS badge-warning">
                        <i class="fal fa-triangle-exclamation"></i>
                        {{ 'documents.legacy' | translate }}
                      </span>
                    }

                    <div class="template__item-date_container">
                      @if (template.created_at) {
                        <div class="template__item-date">
                          <i class="fa-light fa-file-plus"></i>
                          {{ template.created_at | dateTime: 'shortDate' }}
                        </div>
                      }
                      @if (template.created_at !== template.updated_at) {
                        <div class="template__item-date"><i class="fa-regular fa-pen-to-square"></i>{{ template.updated_at | dateTime: 'shortDate' }}</div>
                      }
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }
        @if (!isLoading && !isTemplatesLastPage) {
          <div class="template__pagination">
            <button type="button" class="btn btn-link" (click)="loadTemplates({ page: templatesPageNumber + 1 })">{{ 'documents.loadMoreTemplates' | translate }}</button>
          </div>
        }
      </div>
    </main>

    <main class="document-signers document-signers--mobile-spacing" [class.d-none]="formStep !== FormSteps.signaturePositions">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.positionVisibleSignatures' | translate }}</div>
      </div>

      <label class="document-signers__position" for="mobile-document-position">
        <div type="button" class="sidebar-options-submit sidebar-options-submit--field">{{ 'documents.insertField' | translate }}</div>
      </label>
      <input type="checkbox" class="d-none" name="mobile-document-position" id="mobile-document-position" />
      <label class="document-signers__position-backdrop" for="mobile-document-position"></label>
      <label class="document-signers__position-holder" for="mobile-document-position">
        <h3 class="document-signers__position-title">{{ 'documents.signatureFields' | translate }}</h3>
        <p class="document-signers__position-descr">{{ 'documents.selectSignerAndFieldType' | translate }}</p>
        <div class="document-signers-list">
          @for (signer of signers | uniqueSigners: document?.qualified; track $index) {
            <app-signer-floating-fields-input
              [signatureAction]="signer.action"
              [identification]="signer[signer._extra.signerMainAttribute]"
              [idColor]="idColors[$index % idColors.length]"
              [attr.signer-color-id]="$index % idColors.length"
              [qualified]="document?.qualified"
              [signerQualified]="!!signer?._extra?.isQualified"
              [isCountryBR]="document?.locale?.country === 'BR'"
              [selected]="signer._extra.isSelected"
              [disabled]="isLoading"
              (addFloatingField)="setFloatingFieldFor(signer, $event, idColors[$index % idColors.length])"
            >
            </app-signer-floating-fields-input>
          }
        </div>
      </label>
    </main>
  </aside>
  <aside class="sidebar" [class.file]="!!file && (formStep === FormSteps.mobileFile || formStep === FormSteps.signaturePositions)">
    <!-- Always -->
    <app-document-sidebar-header>
      @switch (formStep) {
        @case (FormSteps.signers) {
          <a class="btn-M btn-text icon-start" [routerLink]="urlParamsService.params.mainPath || backLink">
            <i class="fal fa-chevron-left"></i>
            {{ 'documents.myDocuments' | translate }}
          </a>
        }
        @case (FormSteps.signaturePositions) {
          <a class="btn-M btn-text icon-start" (click)="setFormStep(FormSteps.signers)" [class.d-none]="isUploadingFile">
            <i class="fal fa-chevron-left"></i>
            {{ 'button.back' | translate }}
          </a>
        }
        @case (FormSteps.extraConfigurations) {
          <a
            class="btn-M btn-text icon-start"
            (click)="setFormStep((currentDocumentMainTab === DocumentMainTab.WhatsappFlow && markdown) || isDynamicTemplate ? FormSteps.signers : FormSteps.signaturePositions)"
            [class.d-none]="isUploadingFile"
          >
            <i class="fal fa-chevron-left"></i>
            {{ 'button.back' | translate }}
          </a>
        }
      }
    </app-document-sidebar-header>

    <main class="document-signers" [class.d-none]="formStep !== FormSteps.signers">
      @if (document?.locale?.country && document?.locale?.language) {
        <div class="document-signers__language">
          <div class="d-inline-flex align-items-center">
            <i class="fa-regular fa-language mr-1"></i>
            {{ 'documents.jurisdictionOfDocument' | translate }}
          </div>
          <div class="d-inline-flex align-items-center">
            <button class="btn-S btn-text icon-end mr-1" ngbDropdown placement="bottom-right" title="{{ 'countryCodes.' + (document.locale.country | lowercase) | translate }}">
              <div class="d-inline-flex align-items-center" ngbDropdownToggle container="body" placement="right">
                <div class="text-truncate" style="max-width: 67px">{{ 'countryCodes.' + (document.locale.country | lowercase) | translate }}</div>
                <i class="fal fa-caret-down"></i>
              </div>
              <div class="document-signers__language-dropdown-list" ngbDropdownMenu>
                <input type="text" class="searchInput" placeholder="{{ 'button.search' | translate }}" [(ngModel)]="searchLocaleInputText" (ngModelChange)="filterDropdown($event)" />
                @for (country of countriesFiltered; track $index) {
                  <button
                    class="text-truncate"
                    style="max-width: 145px"
                    ngbDropdownItem
                    (click)="changeLocaleInput('country', country.key)"
                    title="{{ country.value }}"
                    [innerHTML]="country.value | highlight: searchLocaleInputText"
                  ></button>
                }
              </div>
            </button>
            <button class="btn-S btn-text icon-end" ngbDropdown placement="bottom-right" title="{{ document.locale.language }}">
              <div class="d-inline-flex align-items-center" ngbDropdownToggle container="body" placement="right">
                <div class="text-truncate" style="max-width: 40px">{{ document.locale.language | uppercase }}</div>
                <i class="fal fa-caret-down"></i>
              </div>
              <div ngbDropdownMenu>
                @for (language of languages; track $index) {
                  <button ngbDropdownItem (click)="changeLocaleInput('language', language.key)" title="{{ language.value }}">{{ language.value }}</button>
                }
              </div>
            </button>
          </div>
        </div>
      }

      <div class="document-signers-title">{{ 'documents.informSigner' | translate }}</div>
      <div class="document-signers-subtitle" [class.mb-2]="isDynamicTemplate">{{ 'documents.informSignerDesc' | translate }}</div>

      @if (!isDynamicTemplate) {
        <div class="position-relative" #signerToolsSort="ngbTooltip" [ngbTooltip]="tipSignerOrder" container="body" placement="right">
          <app-switch-tabs
            (hover)="signerToolsSort.toggle()"
            name="type"
            [options]="[
              [false, translateService.instant('documents.withoutOrder')],
              [true, translateService.instant('documents.withOrder')]
            ]"
            [(ngModel)]="document.sortable"
            [ngModelOptions]="{ standalone: true }"
            [inputWidth]="'238px'"
          ></app-switch-tabs>

          <button class="btn-S btn-text icon-only floating-button" [class.active]="isLockedOrder" (click)="isLockedOrder = !isLockedOrder">
            @if (isLockedOrder) {
              <i class="fa-regular fa-lock"></i>
            } @else {
              <i class="fa-regular fa-lock-open"></i>
            }
          </button>
        </div>
        @if (showAddMeToList) {
          <div class="document-signers-top">
            @if (currentUser) {
              <button type="button" class="document-signers-button" (click)="addNewSigner(currentUser.email, true); showAddMeToList = false">
                {{ 'documents.addMeToList' | translate }}
              </button>
            }
          </div>
        }
      }
      <div class="document-signers-list" [dndDropzone] (dndDrop)="onDragAndDropSigner($event)">
        <div dndPlaceholderRef></div>

        @for (signer of signers; track $index) {
          <div class="signer" [dndDraggable]="$index" dndEffectAllowed="move">
            <div class="signer-order" [class.d-none]="!document.sortable">
              <div class="signer-order-num" dndHandle>{{ $index + 1 }}&nbsp;<i class="fal fa-sort"></i></div>
            </div>
            <app-signer-input
              [signer]="signer"
              [document]="document"
              [canShowSignerQualifiedCheckbox]="![DocumentMainTab.WhatsappFlow, DocumentMainTab.TemplateUpload].includes(currentDocumentMainTab)"
              [qualified]="document.qualified"
              [context]="isDynamicTemplate ? SignerInputContext.NewDynamicDocument : SignerInputContext.Default"
              [isMarkdown]="currentDocumentMainTab === DocumentMainTab.WhatsappFlow"
              [isCountryBR]="document.locale?.country === 'BR'"
              [validationErrors]="(validationErrors.signers || [])[$index]"
              [class.has-error]="(validationErrors.signers || [])[$index]?.name || (validationErrors.signers || [])[$index]?.email"
              [attr.signer-color-id]="($index + (!isDynamicTemplate || creatorIsSigner ? 0 : 1)) % idColors.length"
              (changeSigner)="onSignerChange(signer)"
              (keydown)="$event.key != 'Enter' || !isDynamicTemplate || $event.preventDefault()"
              [signerIndex]="isDynamicTemplate ? $index + (creatorIsSigner ? 0 : 1) : ''"
            ></app-signer-input>
          </div>
        }
      </div>

      <ng-template #tipSignerOrder>
        <div class="tooltip__title">{{ 'documents.signingOrder' | translate }}</div>
        <div class="tooltip__descr">
          {{ 'documents.whenActive' | translate }}
        </div>
      </ng-template>

      @if (currentDocumentMainTab !== DocumentMainTab.WhatsappFlow && !isDynamicTemplate) {
        <div class="document-signers-sort position-relative" #qualifiedSignatureTooltip="ngbTooltip" [ngbTooltip]="tipQualifiedSignature" container="body" placement="right">
          <label class="document-signers-sort-label" (hover)="qualifiedSignatureTooltip.toggle()">
            <app-switch [(ngModel)]="document.qualified" (ngModelChange)="setQualifiedSignature(document.qualified)"></app-switch>
            <span class="document-signers-sort-text">{{ 'appSelect.qualifiedElectronicSignature' | translate }}</span>
          </label>

          <button class="btn-S btn-text icon-only floating-button" [class.active]="isLockedSignatureType" (click)="isLockedSignatureType = !isLockedSignatureType">
            @if (isLockedSignatureType) {
              <i class="fa-regular fa-lock"></i>
            } @else {
              <i class="fa-regular fa-lock-open"></i>
            }
          </button>
        </div>
      }
      <ng-template #tipQualifiedSignature>
        <div class="tooltip__title">
          {{ 'documents.qualifiedElectronicSignature' | translate }}
        </div>
        <div class="tooltip__descr" [innerHTML]="'documents.qualifiedSignatureDescription' | translate"></div>
      </ng-template>
      @if (document.qualified) {
        <div class="alert-message">
          <p class="mb-1">{{ 'documents.qualifiedElectronicSignature' | translate }}</p>
          <span [innerHTML]="'documents.qualifiedSignatureWarningDescription' | translate"></span>
        </div>
      }
    </main>

    <main class="document-signers document-signers--mobile-none" [class.d-none]="formStep !== FormSteps.signaturePositions">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.positionVisibleSignatures' | translate }}</div>
      </div>
      <div class="document-signers-list">
        @for (signer of signers | uniqueSigners: document?.qualified; track $index) {
          <app-signer-floating-fields-input
            [signatureAction]="signer.action"
            [identification]="signer[signer._extra.signerMainAttribute]"
            [idColor]="idColors[$index % idColors.length]"
            [attr.signer-color-id]="$index % idColors.length"
            [qualified]="document?.qualified"
            [signerQualified]="!!signer?._extra?.isQualified"
            [isCountryBR]="document?.locale?.country === 'BR'"
            [selected]="signer._extra.isSelected"
            [disabled]="isLoading"
            (addFloatingField)="setFloatingFieldFor(signer, $event, idColors[$index % idColors.length])"
          >
          </app-signer-floating-fields-input>
        }
      </div>
    </main>
    <main class="document-signers" [class.d-none]="formStep !== FormSteps.extraConfigurations">
      <div class="document-signers-top">
        <div class="document-signers-title">{{ 'documents.additionalSettings' | translate }}</div>
      </div>
      <app-document-configs-form
        [(document)]="document"
        [isQualified]="isQualified"
        [isPdfA]="isPdfa()"
        [validationErrors]="validationErrors"
        [isNewDocument]="true"
        *ngIf="currentUser"
        #configsForm
      ></app-document-configs-form>
    </main>

    <div class="sidebar-options-submit-holder">
      @if (formStep === FormSteps.signers) {
        @if (isMobile) {
          <button type="button" class="btn-L btn-text-cancel" (click)="setFormStep(FormSteps.mobileFile)">
            {{ 'button.back' | translate }}
          </button>
        }
        <button
          type="button"
          class="btn-L btn-filled d-none"
          [disabled]="isLoading || !signersReady"
          (click)="setFormStep(isMobile && isDynamicTemplate ? FormSteps.extraConfigurations : FormSteps.signaturePositions)"
        >
          {{ 'button.forward' | translate }}
        </button>
        <button
          type="button"
          class="btn-L btn-filled ml-auto"
          [disabled]="isLoading || !signersReady"
          (click)="setFormStep(isMobile && isDynamicTemplate ? FormSteps.extraConfigurations : FormSteps.signaturePositions)"
        >
          {{ 'button.forward' | translate }}
        </button>
      } @else if (formStep === FormSteps.mobileFile) {
        @if (!!file) {
          <button type="button" class="btn-L btn-text-cancel" (click)="removeFile(FormSteps.mobileFile)">
            {{ 'button.back' | translate }}
          </button>
        }
        @if (this.file) {
          <button type="button" class="btn-L btn-filled" [disabled]="isLoading" (click)="setFormStep(FormSteps.signers)">
            {{ 'button.forward' | translate }}
          </button>
        }
      } @else if (formStep === FormSteps.signaturePositions) {
        @if (mergeFiles.length === 1) {
          <button type="button" class="btn-L btn-text-cancel" (click)="setFormStep(FormSteps.signers)" [class.d-none]="isUploadingFile">
            {{ 'button.back' | translate }}
          </button>
        }
        @if (mergeFiles.length > 1) {
          <button type="button" class="btn-L btn-text-cancel" (click)="isMergeFileMobile(FormSteps.mobileFile)" [class.d-none]="isUploadingFile">
            {{ 'button.back' | translate }}
          </button>
        }
        <button type="button" class="sidebar-options-submit sidebar-options-submit--field sidebar-options-submit--mobile" (click)="isMergeFileMobile(FormSteps.mobileFile)">
          {{ 'button.mergeFiles' | translate }}
        </button>
        <button type="button" class="btn-L btn-filled" [disabled]="isLoading" (click)="setFormStep(FormSteps.extraConfigurations)">{{ 'button.forward' | translate }}</button>
      } @else if (formStep === FormSteps.extraConfigurations) {
        <button
          type="button"
          class="btn-L btn-text-cancel"
          (click)="setFormStep((currentDocumentMainTab === DocumentMainTab.WhatsappFlow && markdown) || isDynamicTemplate ? FormSteps.signers : FormSteps.signaturePositions)"
          [class.d-none]="isUploadingFile"
        >
          {{ 'button.back' | translate }}
        </button>
        <button
          type="button"
          class="btn-L btn-filled icon-end"
          [disabled]="isLoading || isUploadingFile || (!isMergeFiles && pdfViewer.pagesCount() === 0 && !isDynamicTemplate && !markdown)"
          (click)="submitDocument()"
        >
          {{ 'button.createDocument' | translate }}
          @if (appService.totalCreditPrice(signers, currentDocumentMainTab === DocumentMainTab.WhatsappFlow) > 0) {
            <span class="monster__badge badge-XS badge-success">
              <i class="fas fa-shield-check"></i>
              -{{ appService.totalCreditPrice(signers, currentDocumentMainTab === DocumentMainTab.WhatsappFlow) }}
            </span>
          }
        </button>
      }
    </div>
    @if (formStep === FormSteps.extraConfigurations && appService.totalCreditPrice(signers, currentDocumentMainTab === DocumentMainTab.WhatsappFlow) > 0) {
      <div class="credits">
        <p class="credits__content submit">
          <i class="fal fa-shield-check"></i>
          <span [innerHTML]="'documents.creatingDocumentCost' | translate: { creditPrice: appService.totalCreditPrice(signers, currentDocumentMainTab === DocumentMainTab.WhatsappFlow) }"></span>
        </p>
      </div>
    }
  </aside>

  <ng-template #tipGoogleDrive>
    <div class="tooltip__tip">{{ 'documents.googleDrive' | translate }}</div>
  </ng-template>

  <section class="models" [class.file]="!!file && formStep === FormSteps.mobileFile" [class.position]="!!file && formStep === FormSteps.signaturePositions">
    <div class="monster__tabs" *ngIf="!isMobile">
      <ng-container *ngIf="formStep !== FormSteps.extraConfigurations; else additionalConfigStep">
        <button
          type="button"
          class="tab__item"
          (click)="changeMainTab(DocumentMainTab.FileUpload)"
          [ngClass]="{ active: currentDocumentMainTab === DocumentMainTab.FileUpload, disabled: currentDocumentMainTab !== DocumentMainTab.FileUpload && (file || markdown || isMergeFiles) }"
        >
          <i class="fa-regular fa-cloud-arrow-up"></i>{{ 'documents.uploadFile' | translate }}
        </button>
        <button
          type="button"
          class="tab__item"
          (click)="changeMainTab(DocumentMainTab.TemplateUpload)"
          [ngClass]="{ active: currentDocumentMainTab === DocumentMainTab.TemplateUpload, disabled: currentDocumentMainTab !== DocumentMainTab.TemplateUpload && (file || markdown || isMergeFiles) }"
        >
          <i class="fa-regular fa-file-lines"></i>{{ 'documents.documentTemplates' | translate }}
        </button>
        <button
          type="button"
          class="tab__item"
          (click)="changeMainTab(DocumentMainTab.WhatsappFlow)"
          [ngClass]="{ active: currentDocumentMainTab === DocumentMainTab.WhatsappFlow, disabled: currentDocumentMainTab !== DocumentMainTab.WhatsappFlow && (file || isMergeFiles) }"
          *ngIf="appService.isAutentiqueDomain()"
        >
          <i class="fa-regular fa-mobile-notch"></i>{{ 'documents.whatsappDocuments' | translate }}
        </button>
      </ng-container>
      <ng-template #additionalConfigStep>
        <button
          type="button"
          class="tab__item"
          (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigDocument)"
          [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigDocument }"
        >
          <i class="fa-regular fa-file-lines"></i>{{ 'settings.document' | translate }}
        </button>
        <button
          type="button"
          class="tab__item"
          (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigEmail)"
          [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigEmail }"
        >
          <i class="fa-regular fa-envelope"></i>{{ 'auth.mail' | translate }}
        </button>
        <button
          type="button"
          class="tab__item"
          (click)="changeDocumentConfigTab(DocumentAdditionalConfigTab.AdditionalConfigWhatsapp)"
          [ngClass]="{ active: currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigWhatsapp }"
          *ngIf="appService.isAutentiqueDomain()"
        >
          <i class="fa-brands fa-whatsapp"></i>{{ 'documents.whatsapp' | translate }}
        </button>
      </ng-template>
    </div>

    <!--    <app-payment-warning [onlyShowExpired]="true"></app-payment-warning>-->

    <div class="models__droparea" #documentUploadWrapper [class.d-none]="file || !currentUser || isMergeFiles || currentDocumentMainTab !== DocumentMainTab.FileUpload">
      <p class="models__droparea-title">{{ 'documents.dragDocumentHere' | translate }}</p>
      <p class="models__droparea-text">{{ 'documents.orClickTo' | translate }}</p>
      <div class="models__droparea-actions">
        <label class="autentique-button autentique-button--size-large">
          <i class="fal fa-file-upload"></i>
          <input
            type="file"
            class="models-submit-field-file"
            multiple
            [accept]="acceptedFileMimeTypes.join(',')"
            (change)="addMultipleFiles($event.target['files'], false); $any($event.target).value = ''"
          />
          {{ 'documents.selectFile' | translate }}
        </label>
        <button type="button" class="models__droparea-floatingButton" (click)="openGooglePicker(false)" [ngbTooltip]="tipGoogleDrive" container="body" placement="top" *ngIf="!isElectron">
          <i class="fab fa-google-drive"></i>
        </button>
      </div>
    </div>

    <div class="models__droparea models__merge" [class.d-none]="file || !currentUser || !isMergeFiles || currentDocumentMainTab === DocumentMainTab.WhatsappFlow">
      <p class="models__droparea-title">{{ 'documents.mergeFiles' | translate }}</p>
      <p class="models__droparea-text mb-2">{{ 'documents.filesWillBeMerged' | translate }}</p>

      <ng-container [ngTemplateOutlet]="mergeFilesList"></ng-container>

      <div class="models__droparea-actions">
        <button
          type="button"
          class="models__droparea-floatingButton"
          (click)="openGooglePicker(true)"
          [disabled]="isUploadingMergeFiles()"
          [ngbTooltip]="tipGoogleDrive"
          container="body"
          placement="top"
          *ngIf="!isElectron"
        >
          <i class="fab fa-google-drive"></i>
        </button>
        <label class="btn btn-M btn-outline btn-secondary icon-start" [class.disabled]="isUploadingMergeFiles()">
          <input
            type="file"
            class="models-submit-field-file"
            multiple
            [accept]="acceptedFileMimeTypes.join(',')"
            [disabled]="isUploadingMergeFiles()"
            (change)="addMultipleFiles($event.target['files'], true); $any($event.target).value = ''"
          />
          <i class="fa fa-plus"></i> {{ 'documents.addMoreFilesDescription' | translate }}
        </label>
        <button class="btn-M btn-outline" type="button" (click)="submitMergeFiles()" [disabled]="isMergeFilesTooLarge() || hasMergeFilesWithErrors() || isUploadingMergeFiles()">
          {{ 'button.merge' | translate }}
        </button>
      </div>
    </div>

    <!--    <div class="models__or" [class.d-none]="file || !currentUser">-->
    <!--      <span class="models__or-title">{{ 'documents.orSelectTemplateDescription' | translate }}</span>-->
    <!--    </div>-->

    <div class="models__container" [class.d-none]="file || !currentUser || isMergeFiles || currentDocumentMainTab !== DocumentMainTab.TemplateUpload">
      <div class="infoLabel">
        <p class="infoLabel-descr">{{ 'documents.documentTemplatesDescription' | translate }}</p>
        <!--        <a class="infoLabel-help_link"><b class="fa-regular fa-circle-question"></b> {{ 'settings.screenHelp' | translate }}</a>-->
      </div>

      <div class="models__head">
        @if (currentUser?.currentPermissions.actions_templates_gr) {
          @if (appService.isAutentiqueDomain() && isAutentiqueUser) {
            <div class="button--w-dropdown">
              <button [routerLink]="['/dinamicos/novo']" class="btn-L btn-text">
                <span class="beta">{{ 'documents.newTemplate' | translate }}</span>
              </button>
              <div class="dropdown-button" ngbDropdown placement="bottom-right">
                <button class="btn-L btn-text icon-only" ngbDropdownToggle container="body" placement="right">
                  <i class="fal fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu>
                  <button ngbDropdownItem routerLink="/modelos/novo">
                    <i class="fal fa-code"></i>
                    {{ 'documents.useLegacyEditor' | translate }}
                  </button>
                </div>
              </div>
            </div>
          } @else {
            <button class="btn-M btn-filled icon-start" [routerLink]="['/modelos/novo']">
              <i class="far fa-file-plus"></i>
              {{ 'documents.newTemplate' | translate }}
            </button>
          }
        }
      </div>
      <div class="template">
        @if (templates && templates.length > 0) {
          <div class="template__list">
            @for (template of templates; track $index) {
              @if (!template.is_dynamic_template || (isAutentiqueUser && appService.isAutentiqueDomain())) {
                <div class="template__item">
                  @if (currentUser?.currentPermissions.actions_templates_gr) {
                    <div appDropdown placement="bottom-right" class="template__item-head_options template__item-head_options--app-dropdown">
                      <button type="button" class="dropdown__toggle-control dropdown__toggle-control--corner dropdown__toggle-control--icon-only" appDropdownToggle>
                        <i class="far fa-ellipsis-v"></i>
                      </button>

                      <div appDropdownMenu>
                        <button type="button" appDropdownItem (click)="editTemplate(template)">
                          <i class="fa-regular fa-pen-to-square"></i>
                          {{ 'button.edit' | translate }}
                        </button>

                        <button type="button" appDropdownItem (click)="openDuplicateTemplateModal(template)">
                          <i class="far fa-copy"></i>
                          {{ 'button.duplicate' | translate }}
                        </button>

                        <button type="button" class="dropdown__item--danger" appDropdownItem (click)="deleteTemplate(template)">
                          <i class="fa-regular fa-trash"></i>
                          {{ 'button.exclude' | translate }}
                        </button>
                      </div>
                    </div>
                  }

                  <div class="template__item-container" (click)="fillTemplate(template)">
                    <div class="template__item-head_container" [style.margin-bottom]="template.is_dynamic_template ? '10px' : ''">
                      <a href="javascript:void(0)" class="template__item-head">
                        <div class="template__item-head_icon">
                          <i class="fal" [class]="template.is_dynamic_template ? 'fa-brackets-curly' : 'fa-code'"></i>
                        </div>
                      </a>
                      <div class="template__item-head_text">
                        <p class="template__item-name">{{ template.name }}</p>
                        <p class="template__item-date">{{ template.user.name }}</p>
                      </div>
                    </div>

                    @if (!template.is_dynamic_template && appService.isAutentiqueDomain() && isAutentiqueUser) {
                      <span class="monster__badge badge-XS badge-warning">
                        <i class="fal fa-triangle-exclamation"></i>
                        {{ 'documents.legacy' | translate }}
                      </span>
                    }

                    <div class="template__item-date_container">
                      @if (template.created_at) {
                        <div class="template__item-date"><i class="fa-light fa-file-plus"></i>{{ template.created_at | dateTime: 'shortDate' }}</div>
                      }
                      @if (template.created_at !== template.updated_at) {
                        <div class="template__item-date"><i class="fa-regular fa-pen-to-square"></i>{{ template.updated_at | dateTime: 'shortDate' }}</div>
                      }
                    </div>
                  </div>
                </div>
              }
            }
          </div>
        }

        @if (!isLoading && !isTemplatesLastPage) {
          <div class="template__pagination">
            <button type="button" class="btn btn-link" (click)="loadTemplates({ page: templatesPageNumber + 1 })">{{ 'documents.loadMoreTemplates' | translate }}</button>
          </div>
        }
      </div>
    </div>

    <div class="models__container" [hidden]="currentDocumentMainTab !== DocumentMainTab.WhatsappFlow || currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigDocument">
      <div class="infoLabel">
        <p class="infoLabel-descr">{{ 'documents.whatsappTemplatesDescription' | translate }}</p>
        <!--        <a class="infoLabel-help_link"><b class="fa-regular fa-circle-question"></b> {{ 'settings.screenHelp' | translate }}</a>-->
      </div>
      <app-markdown-handler (documentMarkdown)="markdown = $event" [formStep]="formStep" *ngIf="pageTopTabLoad[DocumentMainTab.WhatsappFlow]"></app-markdown-handler>
    </div>

    <app-pdf-viewer
      [class.d-none]="!file || currentDocumentMainTab === DocumentMainTab.WhatsappFlow || currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigDocument || isDynamicTemplate"
      [enableEditFloatingFields]="true"
      [qualified]="document?.qualified"
      [isNewSignatureStyle]="document?.new_signature_style"
      [documentFooter]="!isMobile && document?.new_signature_style && formStep !== FormSteps.signaturePositions && document?.footer"
      [documentFooterType]="!isMobile && document?.new_signature_style && document?.footer_type"
      [document]="$any(document)"
      (selectedFieldChange)="selectFloatingFieldInput($event)"
      [documentWhitelabel]="documentWhitelabel"
      [isDocumentWhitelabelLoaded]="isDocumentWhitelabelLoaded"
      #pdfViewer
    >
    </app-pdf-viewer>

    <app-dynamic-document-viewer
      #renderedTemplate
      [content]="dynamicTemplateContent"
      [theme]="dynamicTemplateTheme"
      [class.d-none]="!file || currentDocumentMainTab === DocumentMainTab.WhatsappFlow || currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigDocument || !isDynamicTemplate"
      [scale]="renderedDocumentScale"
      (recalculateScale)="updateRenderedDocumentScale()"
    ></app-dynamic-document-viewer>

    <div
      class="models-float-bottom"
      *ngIf="
        file &&
        (pdfViewer.pagesCount() > 0 || isDynamicTemplate) &&
        !isSettingFloatingFields &&
        currentDocumentMainTab !== DocumentMainTab.WhatsappFlow &&
        currentAdditionalConfigTab === DocumentAdditionalConfigTab.AdditionalConfigDocument
      "
    >
      @if (mergeFiles.length > 1) {
        <button type="button" class="btn btn-primary" (click)="isMergeFile()">{{ 'button.changeFile' | translate }}</button>
      }
      @if (mergeFiles.length === 1 || isDynamicTemplate) {
        <button type="button" class="btn btn-primary" (click)="removeFile()">{{ 'button.changeFile' | translate }}</button>
      }
      <ng-template #tipMergeFiles>
        <div class="tooltip__title">{{ 'documents.mergeFile' | translate }}</div>
        <div class="tooltip__descr">{{ 'documents.selectMultipleFilesDescription' | translate }}</div>
      </ng-template>
      <button
        type="button"
        class="btn btn-primary btn-white"
        [class.d-none]="isDynamicTemplate"
        (click)="isMergeFile()"
        (hover)="toggleMergeFiles.toggle()"
        #toggleMergeFiles="ngbTooltip"
        [ngbTooltip]="tipMergeFiles"
      >
        {{ 'button.mergeFiles' | translate }}
      </button>
    </div>

    <div class="models__container" [hidden]="formStep !== FormSteps.extraConfigurations || currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigEmail">
      <div class="alertMessage size-M default mb-3">
        <i class="fa-regular fa-circle-info"></i>
        <div>
          <span [innerHTML]="'documents.configEmailTemplatesDescription' | translate"></span>
        </div>
      </div>

      <app-document-configs-email
        *ngIf="pageTopTabLoad[DocumentAdditionalConfigTab.AdditionalConfigEmail]"
        [(document)]="document"
        [isNewDocument]="true"
        [validationErrors]="validationErrors"
      ></app-document-configs-email>
    </div>

    <div class="models__container" [hidden]="formStep !== FormSteps.extraConfigurations || currentAdditionalConfigTab !== DocumentAdditionalConfigTab.AdditionalConfigWhatsapp">
      <div class="alertMessage size-M default mb-3">
        <i class="fa-regular fa-circle-info"></i>
        <div>
          <span [innerHTML]="'documents.configWhatsappTemplatesDescription' | translate"></span>
        </div>
      </div>

      <app-document-configs-whatsapp *ngIf="pageTopTabLoad[DocumentAdditionalConfigTab.AdditionalConfigWhatsapp]" [(document)]="document"></app-document-configs-whatsapp>
    </div>
  </section>
</div>

<div class="document-focus-overlay" *ngIf="isSettingFloatingFields" (click)="cancelSettingFloatingFields()"></div>

<ng-template #mergeFilesList>
  <div class="document-list" [dndDropzone] (dndDrop)="onDragAndDropMergeFile($event)">
    <div dndPlaceholderRef></div>
    @for (mergeFile of mergeFiles; track mergeFile.file) {
      <div class="list" [class.is-uploading]="mergeFile.uploading" [class.has-error]="mergeFile.error" [dndDraggable]="$index" [dndDisableIf]="mergeFile.uploading" dndEffectAllowed="move">
        <div class="item" dndHandle>
          <span class="number">
            @if (mergeFile.uploading) {
              <i class="fa fa-spinner fa-spin"></i>
            } @else if (mergeFile.error) {
              <i class="fa fa-exclamation-triangle"></i>
            } @else {
              <strong>{{ $index + 1 }}</strong>
              <i class="fa fa-grip-dots-vertical"></i>
            }
          </span>
          <div class="documents">
            <div class="title">
              <span class="title-text">{{ mergeFile.file.name }}</span>
              @if (mergeFile.pdfa) {
                <span class="monster__badge badge-XS badge-primary">PDF/A</span>
              }
              @if (mergeFile.error) {
                <span class="monster__badge badge-XS badge-danger">{{ 'error' | translate }}</span>
              }
            </div>
            <p class="text">{{ mergeFile.file.size / 1024 | number: '1.0-0' }}kb</p>
          </div>
          <i class="fa-regular fa-trash" [class.disabled]="mergeFile.uploading" (click)="!mergeFile.uploading && deleteMergeFile($index)"></i>
        </div>
      </div>
    }
    @if (isMergeFilesTooLarge()) {
      <div class="models__droparea-alert alert alert-danger" role="alert">
        {{ 'documents.' + (currentUser?.subscription.has_premium_features ? 'totalFileSizeLimit20MB' : 'totalFileSizeLimit5MB') | translate }}
      </div>
    } @else if (hasMergeFilesWithErrors()) {
      <div class="alertMessage size-M error">
        <i class="fa-regular fa-exclamation-triangle"></i>
        <div>{{ 'error_could_not_upload_file' | translate }}</div>
      </div>
    } @else if (mergeFiles.length > 1 && isPdfaInMergeFiles()) {
      <div class="alertMessage size-M warning">
        <i class="fa-regular fa-triangle-exclamation"></i>
        <div>{{ 'documents.pdfaMergeWarning' | translate }}</div>
      </div>
    }
  </div>
</ng-template>
